import { useState } from "react"
import { useTranslation } from "react-i18next"
import StatementCard from "./StatementCard"
import StepHeading from "./StepHeading"

const AUTO_ADVANCE_DELAY_MS = 350

// NOTE: The app's onboarding scale (AgreementScale): emoji sized by strength.
const SCALE = [
  { emoji: "👎", fontSize: 30, value: "1" },
  { emoji: "👎", fontSize: 21, value: "2" },
  { emoji: "🤷", fontSize: 25, value: "3" },
  { emoji: "👍", fontSize: 21, value: "4" },
  { emoji: "👍", fontSize: 30, value: "5" },
]

interface Props {
  id: string
  onAnswer: (answers: string[]) => void
}

export default function LikertStep({ id, onAnswer }: Props) {
  const [selected, setSelected] = useState<string>()
  const { t } = useTranslation()

  const handleSelect = (value: string) => {
    if (selected) return

    setSelected(value)
    setTimeout(() => onAnswer([value]), AUTO_ADVANCE_DELAY_MS)
  }

  return (
    <div className="flex grow flex-col gap-6 pt-4">
      <StepHeading headingKey="pages.onboarding.likertHeading" />

      <div className="flex grow flex-col justify-center">
        <StatementCard text={t(`pages.onboarding.steps.${id}.statement`)} />
      </div>

      <div className="animate-fade-up pb-6 [animation-delay:250ms]">
        <div className="grid h-[68px] grid-cols-5 divide-x divide-vm-line overflow-hidden rounded-vm-md border border-vm-line bg-vm-surface">
          {SCALE.map(({ emoji, fontSize, value }) => (
            <button
              aria-label={t(`pages.onboarding.likert.${value}`)}
              className={`flex items-center justify-center leading-none transition-colors duration-200 active:scale-95 ${
                selected === value ? "bg-vm-primary-soft" : "hover:bg-vm-cream"
              }`}
              key={value}
              onClick={() => handleSelect(value)}
              type="button"
            >
              <span aria-hidden style={{ fontSize }}>
                {emoji}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-2 flex justify-between text-xs font-medium text-vm-muted">
          <span>{t("pages.onboarding.likert.1")}</span>
          <span>{t("pages.onboarding.likert.5")}</span>
        </div>
      </div>
    </div>
  )
}
